import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import IvrCard from "../IvrCard";

function AddMenuOptionCard({ onCreate, disabled, nextDigit }: AddMenuOptionCardProps) {
  return (
    <IvrCard
      footer={null}
      onClick={disabled ? undefined : onCreate}
      className={disabled ? "opacity-50" : "cursor-pointer"}
    >
      <FontAwesomeIcon
        icon={faPlusCircle}
        className="text-gray-dark block mx-auto mb-4 text-5xl"
      />
      <div className="text-gray-dark font-bold text-center">
        Adicionar opção
      </div>
      <div className="text-gray-dark text-xs text-center mt-1">
        {disabled
          ? "Todas as teclas (0-9) em uso"
          : `Tecla ${nextDigit} disponível`}
      </div>
    </IvrCard>
  );
}

export default AddMenuOptionCard;

export type AddMenuOptionCardProps = {
  onCreate: () => void;
  disabled: boolean;
  nextDigit: number | null;
};
